import {AsyncInlineError, streamify, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {UserErrorsFactory} from '../Errors/factory.js'
import {ContactByMailService} from '../Services/ContactByMailService.js'

@streamify('execute')
class ContactByMailUseCase extends UseCase {
  #config
  #service
  #genericUserErrorFactory

  constructor({service, config, genericUserErrorFactory}) {
    super({service, config})

    this.#service = service
    this.#config = config
    this.#genericUserErrorFactory = genericUserErrorFactory
  }

  static create({config}) {
    return new ContactByMailUseCase({
      service: ContactByMailService.create({config}),
      config,
      genericUserErrorFactory: UserErrorsFactory.genericUserError
    })
  }

  @tracer({metric: 'ContactByMailUseCase#execute'})
  @AsyncInlineError()
  async execute({adId, message, buyer}) {
    const [contactError, contactResponse] = await this.#service.execute({
      adId,
      message,
      buyer
    })

    if (contactError) {
      return Promise.reject(this.#genericUserErrorFactory(contactError.toJSON().error))
    }

    return contactResponse.toJSON()
  }
}

export const factory = ContactByMailUseCase.create
